var map = {
	"./en/candidate-facing-components.json": [
		56782,
		782
	],
	"./es/candidate-facing-components.json": [
		3973,
		973
	],
	"./fr/candidate-facing-components.json": [
		79425,
		425
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 60026;
module.exports = webpackAsyncContext;